module.exports = __webpack_public_path__ + "static/img/icon_alipay.a8be026e.png";